/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { icons } from '../../../../../assets';
import { appHistoryPush } from '../../../../../modules/app/appHistory';
import { ELogBusinessEventName, ELogBusinessEventType } from '../../../../../modules/logging/loggingConstants';
import { EOnboardingComponentsId } from '../../../../../modules/onboarding/types/onboardingTypes';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { ExternalRoutePath } from '../../../../../routes/constants/externalRoutes';
import { CLIENT_ID, IRouteParams, RoutePath } from '../../../../../routes/constants/routesConstants';
import { TableFooterNameType } from '../../../../Table/types/tableTypes';
import {
    TTableButtonsGetTranslation,
    TTableButtonsLogBusinessEvent,
    TUseTableFooterButtonsUrl,
} from '../useTableFooterButtons';

const useTableFooterButtonBills = (
    getTranslation: TTableButtonsGetTranslation,
    logBusinessEvent: TTableButtonsLogBusinessEvent,
    tableFooterName: TableFooterNameType,
) => {
    const { clientId } = useParams<IRouteParams>();

    return {
        className: 'table-footer__link link-document',
        dataName: 'document',
        icon: icons.archiveIcon,
        id: AccessComponentKeyEnum.FooterButtonBills,
        onboarding: EOnboardingComponentsId.accountsTableFooterButtonBills,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonBills),

        onClick: useCallback(() => {
            logBusinessEvent(ELogBusinessEventName.USER_SHOW_BILLS, ELogBusinessEventType.common);
            const urlConfig = mapTableFooterNameToUrl[tableFooterName];
            if (!urlConfig) return;

             appHistoryPush(urlConfig.url.replace(CLIENT_ID, clientId));
        }, [logBusinessEvent, tableFooterName, clientId]),
    };
};

const mapTableFooterNameToUrl: Partial<TUseTableFooterButtonsUrl> = {
    [TableFooterNameType.account]: {
        url: RoutePath.bills,
        external: ExternalRoutePath.bills,
    },
    [TableFooterNameType.accountId]: {
        url: RoutePath.billsAccount,
        external: ExternalRoutePath.billsAccount,
    },
};

export default useTableFooterButtonBills;
